import Rails from '@rails/ujs';

export default class MoeSlotRequest {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    $(document).on('click', '.moe-confirm-request-btn', (e) => {
      this.handleSlotRequestAction($(e.currentTarget), $(e.currentTarget).data('confirm-url'), $(e.currentTarget).data('request-id'));
    });
    $(document).on('click', '.moe-reject-request-btn', (e) => {
      if (confirm('Refuser cette demande de rendez-vous ?')) {
        this.handleSlotRequestAction($(e.currentTarget), $(e.currentTarget).data('reject-url'), $(e.currentTarget).data('request-id'));
      }
    });
  }

  handleSlotRequestAction(btn, url, requestId) {
    const data = new URLSearchParams({
      slot_request_id: requestId,
      authenticity_token: $('meta[name="csrf-token"]').attr('content')
    }).toString();
    Rails.ajax({
      url: url,
      type: 'PUT',
      data,
      success: (resp) => {
        if (resp.success) {
          location.reload();
        }
      },
      error: () => {
        alert('Erreur serveur');
      }
    });
  }

  onDestroy() {
    $(document).off('click', '.moe-confirm-request-btn');
    $(document).off('click', '.moe-reject-request-btn');
  }
}
